import React from 'react';
import { useParams } from 'react-router-dom';
import { useCategoriesContext } from '../../contexts/CategoriesContext';
import { useUI } from '../../contexts/UIContext';
import NavBar from '../../components/NavBar/NavBar';
import PrimaryCategories from '../../components/PrimaryCategories/PrimaryCategories';
import SecondaryCategories from '../../components/SecondaryCategories/SecondaryCategories';
import DiscoverSubCategories from '../../components/DiscoverSubCategories/DiscoverSubCategories';
import TrendingSubCategories from '../../components/TrendingSubCategories/TrendingSubCategories';
import JustInSubCategories from '../../components/JustInSubCategories/JustInSubCategories';
import LaunchedSubCategories from '../../components/LaunchedSubCategories/LaunchedSubCategories';
import EmptyState from '../../components/EmptyState/EmptyState';
import Footer from '../../components/Footer/Footer';
import { useCategoryPage } from '../../hooks/useCategoryPage';
import styles from './CategoryPage.module.css';

const CategoryPage = ({ 
  primaryCategory,
  tickerTextId
}) => {
  const { size } = useUI();
  const { category = 'all' } = useParams();
  const { getCategoryIdFromSlug } = useCategoriesContext();
  
  // Obtener ID de categoría del slug
  const selectedCategoryId = getCategoryIdFromSlug(category);

  const { hasData, isLoading } = useCategoryPage({
    primaryCategory,
    selectedCategoryId,
    category
  });

  // Renderizar el subcomponente apropiado
  const renderContent = () => {
    if (isLoading) {
      return null;
    }

    if (!hasData) {
      return (
        <EmptyState
          size={size}
          type={`${primaryCategory} ${selectedCategoryId === 9 ? '' : 'SubCategory'}`}
          categoryId={selectedCategoryId}
        />
      );
    }

    const props = {
      componentSize: size,
      selectedCategoryId
    };

    switch (primaryCategory) {
      case 'Discover':
        return <DiscoverSubCategories {...props} />;
      case 'Trending':
        return <TrendingSubCategories {...props} />;
      case 'Just In':
        return <JustInSubCategories {...props} />;
      case 'Launched':
        return <LaunchedSubCategories {...props} />;
      default:
        return null;
    }
  };

  return (
    <div className={styles.pageContainer}>
      {/* Header fijo */}
      <div className={styles.headerFixed}>
        <NavBar 
          size={size}
          hideBottomSeparator={true}
          tickerTextId={tickerTextId}
        />
        <div className={styles.categoriesContainer}>
          <PrimaryCategories
            size={size}
            selectedCategory={primaryCategory}
          />
          <SecondaryCategories
            size={size}
            selectedCategory={selectedCategoryId}
          />
          <div className={styles.separator} />
        </div>
      </div>

      {/* Contenedor scrolleable */}
      <div className={styles.scrollContainer}>
        <main className={styles.mainContent}>
          {renderContent()}
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default CategoryPage;